<template>
  <div class="instashare-buy-now__timer-wrap">
    <div class="instashare-buy-now__timer-lead-in">Offer ends in:</div>
    <div class="instashare-buy-now__timer-time">{{ countdown }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, { moment })

export default {
  name: 'InstashareTimer',
  props: {
    availableUntilDateTime: { type: String, default: null, required: false }
  },
  data: function () {
    return {
      countdown: null
    }
  },
  mounted () {
    let eventTime = null

    if (this.availableUntilDateTime !== null) {
      eventTime = Vue.moment.tz(this.availableUntilDateTime, 'MM/DD/YYYY hh:mm:ss a', 'America/Chicago') // set time to match the server timezone
    } else {
      eventTime = Vue.moment().add(1, 'd').hours(0).minutes(0).seconds(0)
    }

    const currentTime = Vue.moment()
    const interval = 1000

    let duration = Vue.moment.duration(eventTime - currentTime)

    setInterval(
      () => {
        duration = Vue.moment.duration(duration - interval, 'milliseconds')

        const days = duration.days().toString().padStart(2, '0')
        const hours = duration.hours().toString().padStart(2, '0')
        const minutes = duration.minutes().toString().padStart(2, '0')
        const seconds = duration.seconds().toString().padStart(2, '0')

        if (duration.days() > 0) {
          this.countdown = `${days}:${hours}:${minutes}:${seconds}`
        } else {
          this.countdown = `${hours}:${minutes}:${seconds}`
        }
      },
      interval
    )
  },
  methods: {
    padIfNeeded: function (str, char) {
      if (str.toString().length === 1) {
        return char + str
      }

      return str
    }
  }
}
</script>



// WEBPACK FOOTER //
// WebResources/vue/proofs/index/components/InstashareTimer.vue